import type { Type } from '@warp-drive/core/types/symbols';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Company as CompanyModel } from './company.type';

// tio-payment validates TASAssistanceManner by enum value; a bare member name is a 422.
export const PAYMENT_MANNERS = [
  'TAS.AssistanceManner.REIMBURSEMENT',
  'TAS.AssistanceManner.COURSE_CASH',
] as const;
export type PaymentManner = (typeof PAYMENT_MANNERS)[number];
export const DEFAULT_PAYMENT_MANNER: PaymentManner = 'TAS.AssistanceManner.REIMBURSEMENT';

export const PAYMENT_MANNER_LABEL_KEYS: Record<PaymentManner, string> = {
  'TAS.AssistanceManner.REIMBURSEMENT': 'payments.manner.reimbursement',
  'TAS.AssistanceManner.COURSE_CASH': 'payments.manner.course_cash',
};

export interface TasPaymentResource {
  readonly [Type]: 'tas-payment';
  id: string | null;
  paymentDate: string;
  description: string;
  state: string;
  paymentType: string;
  paymentManner: PaymentManner | string;
  reportFilePaths: string[] | null;
  settleFilePath: string | null;
  jpmFilePath: string | null;
  feeOnly: boolean;
  paymentFilePaths: string[];
  /**
   * PaperTrail "whodunnit" audit value — NOT a guaranteed display string. Holds
   * a user foreign key (numeric string, or number) when an authenticated user
   * made the change, a non-numeric marker string (e.g. "Tuition.io Payments")
   * for system/seed actions, or a JSONB audit object. Resolve to a human name
   * with `resolveAuditUserName` (tio-common/utils/resolve-audit-user).
   */
  createdBy: string | number | Record<string, unknown> | null;
  stats: Record<string, unknown>;

  company: CompanyModel;
}

export interface TasPayment extends WithLegacy<TasPaymentResource> {}
